<template>
  <model-form
    :model="bookingWeek"
    max-content-width="100%"
    lockable
    :title="'Booking Week of ' + bookingWeek.date.i18n('date') + `, ${currentSite.name}.`"
    :custom-save-function="bookingWeek.saveBookingWeek"
  >
    <div class="row justify-between">
      <div
        class="row"
        style="flex-grow: 1"
      >
        <q-tabs
          v-model="tab"
          style="flex-grow: 1"
          align="justify"
        >
          <q-tab
            name="plan-elements"
            label="1. Plan Elements"
          />
          <q-tab
            name="title-selection"
            label="2. Title Selection"
          />
          <q-tab
            name="plan-layout"
            label="3. Plan Layout"
          />
          <q-tab
            name="schedule"
            label="4. Schedule"
          />
        </q-tabs>
      </div>
      <q-btn
        icon="description"
        class="q-ml-md"
        :color="bookingWeek.notes ? 'warning' : 'grey-8'"
        size="md"
        dense
        round
        flat
        @click="showNotesDialog = true"
      />
    </div>
    <q-tab-panels
      v-model="tab"
      keep-alive
    >
      <q-tab-panel
        name="plan-elements"
      >
        <q-card-section>
          <booking-week-detail
            :booking-week="bookingWeek"
          />
        </q-card-section>
      </q-tab-panel>
      <q-tab-panel
        name="title-selection"
      >
        <q-card-section>
          <title-plan-list
            :booking-week="bookingWeek"
          />
        </q-card-section>
      </q-tab-panel>

      <q-tab-panel
        name="plan-layout"
      >
        <q-card-section>
          <combined-layout
            ref="combinedLayout"
            :booking-week="bookingWeek"
            :schedule="bookingWeek.finalSiteSchedule"
            @preview-layout="value => previewLayout = value"
            @previewing-action="value => previewingAction = value"
          />
        </q-card-section>
      </q-tab-panel>

      <q-tab-panel
        name="schedule"
      >
        <q-card-section>
          <schedule
            v-show="!bookingWeek.batchSavingInProgress"
            :booking-week="bookingWeek"
            :preview-layout="previewLayout"
            :previewing-action="previewingAction"
          />
        </q-card-section>
      </q-tab-panel>
    </q-tab-panels>
    <notes-dialog
      v-model="showNotesDialog"
      :model="bookingWeek"
    />
  </model-form>
</template>

<script>

import { date } from 'quasar'
import BookingWeekDetail from 'src/modules/admin/booking-week/components/BookingWeekDetail'
import CombinedLayout from 'src/modules/admin/booking-week/components/CombinedLayout'
import TitlePlanList from 'src/modules/admin/booking-week/components/TitlePlanList'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import NotesDialog from 'src/modules/admin/components/NotesDialog'
import Schedule from 'src/modules/admin/schedule/Schedule'

export default {
  name: 'BookingWeekForm',
  components: {
    ModelForm,
    BookingWeekDetail,
    CombinedLayout,
    TitlePlanList,
    Schedule,
    NotesDialog
  },
  data () {
    return {
      previewLayout: {},
      previewingAction: false,
      tab: 'schedule',
      date,
      showNotesDialog: false
    }
  },
  configuration: ['currentSite'],
  models: {
    bookingWeek: {
      watchQuery: false,
      planElements: {
        bookingWeekMovies: {
          movie: {
            customPriceCard: {
              fields: ['id', 'name']
            },
            showingBadges: 'default',
            marathonMovies: 'default'
          }
        },
        parentPlanElement: {
          fields: ['id', 'name']
        },
        showingBadges: 'default'
      },
      site: {
        screens: 'default',
        timeSlots: 'default',
        priceCards: 'default'
      },
      defaultSiteSchedule: 'default',
      showings: {
        fields: [
          'id', 'time', 'ticketsExist', 'ticketsSold', 'published', 'predictedAttendance',
          'overrideSeatChart', 'hasSeatChart', 'overridePriceCard', 'customPriceCardId',
          'overridePostStartTimeBufferMinutes', 'customPostStartTimeBufferMinutes',
          'overrideMaxTicketsPerOrderPerShowing', 'maxTicketsPerOrderPerShowing',
          'customHeldSeatCount', 'customMarathonSeatCount', 'overrideHeldSeatCount',
          'overrideMarathonSeatCount', 'overrideShowingBadges', 'allowWithoutMembership',
          'disableTheaterSeatDelivery', 'qrItemOrderingOnly', 'allowConsumerRefunds',
          'allowConsumerQrTabWithoutPaymentMethod', 'private', 'isPreview',
          'isMarathon', 'hasMarathon', 'allowSalesInMarathon',
          'overrideReservedSeating', 'overrideReservedSeatingValue'
        ],
        customPriceCard: {
          fields: ['id', 'name']
        },
        movie: {
          fields: ['id', 'name', 'posterImage', 'duration', 'overridePriceCard'],
          customPriceCard: {
            fields: ['id', 'name']
          },
          showingBadges: 'default'
        },
        movieTerm: {
          fields: ['id', 'abbreviation'],
          showingBadges: 'default'
        },
        bookingWeekMovie: {
          movie: 'scheduler',
          planElement: {
            fields: ['id', 'name', 'showingBadges', 'color', 'overridePriceCard'],
            customPriceCard: {
              fields: ['id', 'name']
            },
            showingBadges: 'default'
          }
        },
        screen: {
          fields: ['id', 'overridePriceCard'],
          customPriceCard: {
            fields: ['id', 'name']
          },
          showingBadges: 'default'
        },
        additionalShowingBadges: 'default',
        customShowingBadges: 'default',
        customSeatChart: {
          fields: ['id', 'name']
        },
        predictedAttendance: true,
        showings: {
          movie: {
            fields: ['id', 'name', 'posterImage', 'duration', 'overridePriceCard'],
            customPriceCard: {
              fields: ['id', 'name']
            },
            showingBadges: 'default'
          },
          movieTerm: {
            fields: ['id', 'abbreviation'],
            showingBadges: 'default'
          },
          screen: {
            fields: ['id', 'overridePriceCard'],
            customPriceCard: {
              fields: ['id', 'name']
            },
            showingBadges: 'default'
          },
          customPriceCard: {
            fields: ['id', 'name']
          },
          additionalShowingBadges: 'default',
          customShowingBadges: 'default',
          customSeatChart: {
            fields: ['id', 'name']
          },
          predictedAttendance: true
        }
      }
    }
  },
  methods: {
    beforeShow () {
      this.bookingWeek.actualScheduleInitialized = false
      this.bookingWeek.computedLayoutInitialized = false
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
